import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetAgeCertificationsQueryVariables = Types.Exact<{
	country: Types.Scalars['Country'];
}>;

export type GetAgeCertificationsQuery = { __typename?: 'Query' } & {
	organizations: Array<{ __typename?: 'AgeCertification' } & Pick<Types.AgeCertification, 'organization'>>;
	movies: Array<
		{ __typename?: 'AgeCertification' } & Pick<Types.AgeCertification, 'technicalName'> & {
				id: Types.AgeCertification['ageCertificationId'];
			}
	>;
	shows: Array<
		{ __typename?: 'AgeCertification' } & Pick<Types.AgeCertification, 'technicalName'> & {
				id: Types.AgeCertification['ageCertificationId'];
			}
	>;
};

export const GetAgeCertificationsDocument = gql`
	query GetAgeCertifications($country: Country!) {
		organizations: ageCertifications(country: $country) {
			organization
		}
		movies: ageCertifications(country: $country, objectType: MOVIE) {
			id: ageCertificationId
			technicalName
		}
		shows: ageCertifications(country: $country, objectType: SHOW) {
			id: ageCertificationId
			technicalName
		}
	}
`;
